import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Card } from '@sorare/core/src/components/card/Card';
import { ANY_SPORT_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { BuyCongratsScreen } from '../BuyCongratsScreen';
import type { BuyCommonPlayerCongratsScreen_commonPlayer } from './__generated__/index.graphql';

type Props = {
  commonPlayer: BuyCommonPlayerCongratsScreen_commonPlayer & {
    __typename: 'CommonPlayer';
  };
  open: boolean;
  onClose: () => void;
};

export const BuyCommonPlayerCongratsScreen = ({
  commonPlayer,
  open,
  onClose,
}: Props) => {
  const { generateSportContextPath } = useSportContext();
  return (
    <BuyCongratsScreen
      main={<Card card={commonPlayer} />}
      fallbackIosRoute={generateSportContextPath(ANY_SPORT_PLAY)}
      playerDisplayName={commonPlayer.anyPlayer.displayName}
      open={open}
      onClose={onClose}
    />
  );
};

BuyCommonPlayerCongratsScreen.fragments = {
  commonPlayer: gql`
    fragment BuyCommonPlayerCongratsScreen_commonPlayer on CommonPlayer {
      id
      anyPlayer {
        slug
        displayName
      }
      ...Card_commonPlayer
    }
    ${Card.fragments.commonPlayer}
  ` as TypedDocumentNode<BuyCommonPlayerCongratsScreen_commonPlayer>,
};
